export const ORDER_STATUS_OPTIONS = [
  { value: '', label: 'All' },
  { value: 'WAITLIST', label: 'Waitlist' },
  { value: 'PENDING', label: 'Pending' },
  { value: 'APPROVED', label: 'Accepted' },
  { value: 'SHIPPED', label: 'Shipped' },
  { value: 'DELIVERED', label: 'Delivered' },
  { value: 'CANCELLED', label: 'Cancelled' },
  { value: 'REJECTED', label: 'Rejected' },
  { value: 'PICKED_UP', label: 'Picked Up' },
];

export const ORG_ORDER_STATUS_OPTIONS = [
  { value: '', label: 'All' },
  { value: 'PENDING', label: 'Pending' },
  { value: 'WAITLIST', label: 'Waitlist' },
  { value: 'APPROVED', label: 'Accepted' },
  { value: 'REJECTED', label: 'Rejected' },
  { value: 'SHIPPED', label: 'Shipped' },
  { value: 'DELIVERED', label: 'Delivered' },
  { value: 'CANCELLED', label: 'Cancelled' },
  { value: 'PICKED_UP', label: 'Picked Up' },
];

export const UNACTIONABLE_STATUSES = ['CANCELLED', 'REJECTED', 'DELIVERED', 'SHIPPED'];
